<template>
  <div class="wraper">
    <div class="block" style="float:left">
      <i class="el-icon-goods">SKU商品管理</i>
    </div>
    <div class="block" style="float:right;margin-bottom:10px">
      <el-input v-model="search" style="width:200px" size="mini" placeholder="请输入搜索内容" clearable
                @keyup.enter.native="searchTable"></el-input>
      <el-button @click="searchTable" size="mini" type="primary">搜索</el-button>
      <el-button @click="exportTable" size="mini" type="primary">导出报表</el-button>
    </div>
    <el-table
      ref="filterTable"
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="className"
        label="商品分类"
      >
      </el-table-column>
      <el-table-column
        prop="goodsNum"
        label="商品编码">
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="商品名称"

        width="200">
      </el-table-column>
      <el-table-column
        prop="price"

        label="商品价格">
      </el-table-column>
      <el-table-column
        prop="createTime"

        width="200"
        label="创建时间">
      </el-table-column>
      <el-table-column
        prop="goodsImg"
        label="商品图片"
      >
        <template slot-scope="scope">
          <el-popover
            placement="right"
            title=""
            trigger="hover">
            <img :src="scope.row.goodsImg" style="max-height: 250px;max-width: 230px"/>
            <img slot="reference" :src="scope.row.goodsImg" :alt="scope.row.goodsImg"
                 style="max-height: 50px;max-width: 130px">
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">修改
          </el-button>
          <!--<el-button-->
          <!--size="mini"-->
          <!--type="danger"-->
          <!--@click="handleDelete(scope.$index, scope.row)">删除-->
          <!--</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div>
      <el-dialog title="编辑商品SKU" :visible.sync="dialogFormVisible" center width="30%">
        <el-form :model="form">
          <el-form-item label="商品ID" :label-width="formLabelWidth">
            <el-input v-model="form.id" :disabled="true" size="mini" style="width:220px"></el-input>
          </el-form-item>
          <el-form-item label="商品名称" :label-width="formLabelWidth">
            <el-input v-model="form.goodsName" autocomplete="off" size="mini" placeholder="请输入商品名称"
                      style="width:220px"></el-input>
          </el-form-item>
          <el-form-item label="商品编码" :label-width="formLabelWidth">
            <el-input v-model="form.goodsNum" :disabled="true" autocomplete="off" size="mini" placeholder="请输入商品编码"
                      style="width:220px"></el-input>
          </el-form-item>
          <el-form-item label="商品分类" :label-width="formLabelWidth">
            <el-select v-model="form.goodsClass" size="mini" placeholder="请选择商品分类">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.className"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单价（元）" :label-width="formLabelWidth">
            <el-input v-model="form.goodsPrice" autocomplete="off" size="mini" placeholder="请输入商品单价"
                      style="width:220px"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clearForm">取 消</el-button>
          <el-button type="primary" @click="editGoods">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div style="text-align: center;margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                tableData: [],
                options: [],
                total: 0,
                pagesize: 10,
                currentPage: 1,
                search: "",
                dialogFormVisible: false,
                form: {
                    id: '',
                    goodsImg: '',
                    goodsName: '',
                    goodsNum: '',
                    goodsClass: '',
                    goodsPrice: '',
                    goodsSize: ''
                },
                formLabelWidth: '100px'
            }
        },
        mounted() {
            this.getData()
            this.getClassData()
        },
        methods: {
            getData() {
                var param = {pageSize: this.pagesize, pageNum: this.currentPage}
                if (this.search != "") {
                    param.search = this.search
                }
                // get
                this.$ajax.get('data/goods/goodsList', {
                    params: param
                }).then((res) => {
                    var data = res.data.data
                    this.total = data.total
                    this.tableData = data.list
                    this.pagesize = data.pageSize
                }).catch((err) => {
                    this.$message.error('请求goods失败')
                })
            },
            getClassData() {
                // get
                this.$ajax.get('/data/goods/goodsClassList', {
                    params: {pageSize: 10000, pageNum: 1}
                }).then((res) => {
                    this.options = res.data.data.list;
                }).catch((err) => {
                    this.$message.error('请求class失败')
                })
            },
            searchTable() {
                this.getData()
            },
            formatter(row, column) {
                return row.address
            },
            handleSizeChange: function (size) {
                this.pagesize = size;
                this.currentPage = 1;
                this.getData()
            },
            handleCurrentChange: function (currentPage) {
                this.currentPage = currentPage;
                this.getData()
            },
            exportTable: function () {
                var list;
                var param = {pageSize: 10000, pageNum: 1}
                this.$ajax.get('data/goods/goodsList', {
                    params: param
                }).then((res) => {
                    list = res.data.data.list
                    require.ensure([], () => {
                        const {export_json_to_excel} = require('../../vendor/Export2Excel');
                        const tHeader = ["序号", "商品分类", "商品编码", "商品名称", "商品价格", "创建时间"];
                        const filterVal = ["id", "className", "goodsNum", "goodsName", "price", "createTime"];
                        const data = this.formatJson(filterVal, list);
                        export_json_to_excel(tHeader, data, '商品SKU');
                    })
                }).catch((err) => {
                    this.$message.error('请求goods失败')
                })

            },
            formatJson: function (filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            clearForm: function () {
                this.form = {}
                this.dialogFormVisible = false
            },
            handleEdit: function (index, row) {
                this.form = {
                    id: '',
                    goodsImg: '',
                    goodsName: '',
                    goodsNum: '',
                    goodsClass: '',
                    goodsPrice: '',
                    goodsSize: ''
                }
                this.form.id = row.id;
                this.goodsImg = row.goodsImg;
                this.form.goodsClass = row.goodsClassId;
                this.form.goodsName = row.goodsName;
                this.form.goodsNum = row.goodsNum;
                this.form.goodsPrice = row.price;
                this.form.goodsSize = row.size;
                this.dialogFormVisible = true
            },
            editGoods: function () {
                this.$confirm('此操作将修改商品信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$ajax.post('data/goods/editGoods', {
                        id: this.form.id,
                        goodsNum: this.form.goodsNum,
                        goodsName: this.form.goodsName,
                        goodsClassId: this.form.goodsClass,
                        price: this.form.goodsPrice,
                        size: this.form.goodsSize
                    }).then((res) => {
                        if (res.data.code == 200) {
                            this.$message({
                                message: res.data.msg,
                                type: 'success'
                            });
                            this.clearForm()
                            this.getData()
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch((err) => {
                        this.$message.error('请求失败')
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消修改'
                    });
                });
            },
            handleDelete: function (index, row) {
                this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$ajax.post('data/goods/deleteGoods', {
                        goodsId: row.id
                    }).then((res) => {
                        if (res.data.code == 200) {
                            this.$message({
                                message: res.data.msg,
                                type: 'success'
                            });
                            this.getData()
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch((err) => {
                        this.$message.error('请求失败')
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/goods/goods.vue